import { Pipe, PipeTransform } from '@angular/core';

import { isCounterpartyMessage } from 'src/shared/util/message-sender';

// True when a shared-inbox message is from the conversation's counterparty (the
// guest or pro) and so should render on the LEFT. Everything else is our side
// and renders on the RIGHT. Pure pipe so it's memoized per from_member.
@Pipe({
  name: 'isCounterpartyMessage',
  standalone: true,
})
export class IsCounterpartyMessagePipe implements PipeTransform {
  transform(fromMember: { type?: string } | null | undefined): boolean {
    return isCounterpartyMessage(fromMember);
  }
}
